import { makeStyles } from "@material-ui/core/styles";

const userScoreStyles = makeStyles((theme) => ({
  root: {
    backgroundColor: theme.palette.secondary.light,
    borderRadius: "10px",
    padding: "10px",
    display: "flex",
    flexDirection: "column",
    gap: "8px",
  },
  userScoreText: {
    [theme.breakpoints.down("xl")]: {
      fontSize: "20px !important",
    },
    [theme.breakpoints.down("lg")]: {
      fontSize: "15px !important",
    },
    [theme.breakpoints.down("md")]: {
      fontSize: "12px !important",
    },
  },
  scorePoint: {
    fontSize: "20px !important",
    backgroundColor: "#6C65D9",
    padding: "8px 12px",
    minWidth: "70px",
    [theme.breakpoints.down("xl")]: {
      fontSize: "40px !important",
    },
    [theme.breakpoints.down("lg")]: {
      fontSize: "36px !important",
    },
    [theme.breakpoints.down("md")]: {
      fontSize: "20px !important",
    },
  },
  keepUp: {
    color: "#6C65D9",
    [theme.breakpoints.down("xl")]: {
      fontSize: "20px !important",
    },
    [theme.breakpoints.down("lg")]: {
      fontSize: "16px !important",
    },
    [theme.breakpoints.down("md")]: {
      fontSize: "14px !important",
    },
  },

  //expanded view styles
  avatarContainer: {
    display: "flex",
    alignItems: "center",
    gap: "8px",
    backgroundColor: "#252A38",
    padding: "6px 8px",
    borderRadius: "5px",
  },
  avatar: {
    fontSize: "14px !important",
    backgroundColor: "#6C65D9 !important",
    width: "30px !important",
    height: "30px !important",
  },
  datePickerContainer: {
    display: "flex",
    alignItems: "center",
    direction: "row",
    justifyContent: "space-between",
  },
  datePickerDiv: {
    // width: "93%",
    overflowY: "hidden",
    height: "4.3rem",
    marginTop: "-9px",
    borderRadius: "4px",
    display: "flex",
    alignItems: "normal",
  },
  searchQuery: {
    padding: "5px",
    borderRadius: "5px",
    backgroundColor: theme.palette.secondary.light,
    minHeight: "25px",
  },
  datePickerComponent: {
    // marginLeft: "4px",
    // marginBottom: "2.2px",
    padding: "9px",
    borderRadius: "5px",
    backgroundColor: theme.palette.secondary.light,
    width: "150px",
    minHeight: "28px",
  },
}));

export default userScoreStyles;
